import { DatePipe } from '@angular/common';
import { FormControl, Validators } from '@angular/forms';
import { BaseDefaultListFilterComponent } from './base-default-list-filter-component';
import { Component } from "@angular/core";
import { FormGroup } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
    selector: 'default-list-filter',
    templateUrl: './default-list-filter.component.html',
    providers: [ DatePipe ]
})
export class DefaultListFilter extends BaseDefaultListFilterComponent {

    constructor(protected datePipe: DatePipe
    ){
        super(datePipe);
    }

    ngOnInit(){
        let date = new Date();
        this.filterFormGroup = new FormGroup({
            DateFrom: new FormControl(new NgbDate(date.getFullYear(), 1, 1), [ Validators.required ]),
            DateTo: new FormControl(new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate()), [ Validators.required ])
        })
    }

    //collapsed: boolean = true;
}